// Keys must stay in sync with the SEVERITY constant in AlertConfigCard.jsx
const SEVERITY_KEY_MAP = {
  Critical: "critical",
  "High Severity": "highSeverity",
  Warning: "warning",
};

export function buildAlertListParams(selectedFilters, searchTerms, page, pageSize) {
  const params = { page, pageSize };
  if (selectedFilters?.protocolName?.length) params.protocolNames = selectedFilters.protocolName;
  if (selectedFilters?.category?.length) params.alertTypes = selectedFilters.category;
  if (selectedFilters?.batteryEntity?.length) params.entityAffected = selectedFilters.batteryEntity;
  if (selectedFilters?.configName?.length) params.configNames = selectedFilters.configName;
  // Criticality options are severity names (e.g. "Critical"), not level IDs.
  if (selectedFilters?.criticality?.length) params.severityNames = selectedFilters.criticality;
  if (searchTerms?.terms?.length) params.alertDescriptions = searchTerms.terms;
  return params;
}

function formatThreshold(val) {
  if (val == null) return "—";
  const n = parseFloat(val);
  return isNaN(n) ? "—" : `${n} min`;
}

export function transformAlertToCard(apiAlert) {
  const severity = {};
  const severityLevelIDs = {};
  let resolutionCondition = "—";

  (apiAlert.alertSeverityMeta || []).forEach(({ severityLevel, severityLevelID, alertDisplayCondition }) => {
    const key = SEVERITY_KEY_MAP[severityLevel];
    if (key) {
      if (alertDisplayCondition) severity[key] = alertDisplayCondition;
      severityLevelIDs[key] = severityLevelID;
    } else if (severityLevel === "Resolved") {
      resolutionCondition = alertDisplayCondition || "—";
    }
  });

  const h = apiAlert.hierarchy || "";
  const batteryEntity = h ? h.charAt(0).toUpperCase() + h.slice(1) : "—";

  return {
    id: apiAlert.id,
    alertName: apiAlert.alertDescription,
    alertType: apiAlert.alertType || "—",
    batteryEntity,
    protocols: (apiAlert.protocols || []).map((p) => p.name),
    severity,
    severityLevelIDs,
    severityDetails: null,
    resolutionCondition,
    expirationCondition: "N/A",
    persistenceDuration: formatThreshold(apiAlert.activationTimeThreshold),
    cooldownDuration: formatThreshold(apiAlert.resolutionTimeThreshold),
    isEnabled: true,
  };
}
